import React from 'react';
import PropTypes from 'prop-types';
import { $, add } from 'moneysafe';

import { APP_CURRENCY_NAME } from 'config/constants';

import style from './ProductActions.module.scss';

UpdateRentalTerms.propTypes = {
    order: PropTypes.object,
    selectedRentalPeriod: PropTypes.object,
    product: PropTypes.object
};

function UpdateRentalTerms({ order, selectedRentalPeriod, product }) {
    const calcTotalPrice = () => {
        if (product.attributes.storage && product.attributes.storage.values.length !== 0) {
            const attribute = product.attributes.storage.values.find(e => e.id === order.product_attribute_value_id);
            let attributePrice = 0;

            if (attribute?.price_impact) {
                attributePrice = attribute.price_impacts.find(e => e.rental_period_id === selectedRentalPeriod.id).price_impacts;
            }

            const selectedRentalPeriodPrice = selectedRentalPeriod.price;

            return formatAmount(add($(attributePrice), $(selectedRentalPeriodPrice)).toString());
        } else {
            return formatAmount(order.total);
        }
    };

    const formatAmount = (amount) => {
        amount = parseFloat(amount);
        amount = amount.toFixed(0);

        return amount;
    };

    return (
        <div className={style.priceContainer}>
            <span className={style.content}>Subscription Amount:</span>
            <span className={style.price}>{APP_CURRENCY_NAME} {calcTotalPrice()}/mo</span>
        </div>
    );
}

export default UpdateRentalTerms;
